/**
 * @generated SignedSource<<efed0964015843b2d922663254c0f353>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteHydrantManufacturerInput = {
  hydrantManufacturerId: string;
  clientMutationId?: string | null;
};
export type HydrantManufacturersTableDeleteHydrantManufacturerMutation$variables = {
  input: DeleteHydrantManufacturerInput;
};
export type HydrantManufacturersTableDeleteHydrantManufacturerMutationVariables = HydrantManufacturersTableDeleteHydrantManufacturerMutation$variables;
export type HydrantManufacturersTableDeleteHydrantManufacturerMutation$data = {
  readonly deleteHydrantManufacturer: {
    readonly hydrantManufacturer: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type HydrantManufacturersTableDeleteHydrantManufacturerMutationResponse = HydrantManufacturersTableDeleteHydrantManufacturerMutation$data;
export type HydrantManufacturersTableDeleteHydrantManufacturerMutation = {
  variables: HydrantManufacturersTableDeleteHydrantManufacturerMutationVariables;
  response: HydrantManufacturersTableDeleteHydrantManufacturerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHydrantManufacturerPayload",
    "kind": "LinkedField",
    "name": "deleteHydrantManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantManufacturer",
        "kind": "LinkedField",
        "name": "hydrantManufacturer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantManufacturersTableDeleteHydrantManufacturerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HydrantManufacturersTableDeleteHydrantManufacturerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ffd9c5ca5d52c1e912eb44254e758d7f",
    "id": null,
    "metadata": {},
    "name": "HydrantManufacturersTableDeleteHydrantManufacturerMutation",
    "operationKind": "mutation",
    "text": "mutation HydrantManufacturersTableDeleteHydrantManufacturerMutation(\n  $input: DeleteHydrantManufacturerInput!\n) {\n  deleteHydrantManufacturer(input: $input) {\n    hydrantManufacturer {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d2c8d64bf82e96ee6cc6bc92a3aea01";

export default node;
